import { Box, Typography } from "@mui/material";

const EmailSendingLoader = () => {
  return (
    <Box
      sx={{
        position: "absolute",

        inset: 0, // same as top:0 left:0 right:0 bottom:0

        backgroundColor: "#f3f3f3",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
        flexDirection: "column",
        textAlign: "center",
        gap: 2,
      }}
    >
      <img
        src="/assests/images/planeLoader.gif" // your image path
        alt="sending"
        style={{ width: 120 }}
      />

      <Typography variant="h5" fontWeight={600}>
        Hold On !
      </Typography>

      <Typography variant="body1" sx={{ maxWidth: 350 }}>
        We’re sending the email to let him know that his campaign is ready
      </Typography>
    </Box>
  );
};

export default EmailSendingLoader;
